// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactsSection_container__hLo8t","details":"ContactsSection_details__3cqjA","title":"ContactsSection_title__2ilfD","map":"ContactsSection_map__1RsDD"};